/**
 * Shared PostgREST `select()` fragments for the bank-feed match feature.
 *
 * These embeds drive the row-level match badges and the per-transaction match
 * indicator. They were previously copy-pasted across every transaction-list
 * hook (useAccountsPayable / useAccountsReceivable / useExpenses /
 * useLedgerTransactions / useEntityLedgerTransactions / useCurrencyTransfer);
 * a single forgotten copy silently breaks bank detection or the import links in
 * that grid with no type error. Interpolate these constants into the select
 * template instead (PostgREST ignores whitespace, so the single-line form is
 * equivalent to the previous multi-line literals).
 *
 * Lives in @releve/shared (not apps/web) because the Hono expense read
 * handlers interpolate the same fragments server-side — the web copy at
 * `apps/web/src/integrations/supabase/accountingSelects.ts` is a re-export
 * shim kept for existing importers.
 */
/**
 * A transaction's bank-feed import links: matched allocations (via the
 * `accounting_import_matches` join — `!transaction_id` disambiguates the two
 * FKs to `ledger_transactions`) plus created-from imports. Embed on any
 * `ledger_transactions` row (creating txn, payment txn).
 */
export const IMPORT_MATCH_EMBED = 'matched_imports:accounting_import_matches!transaction_id(import:accounting_imports!import_id(id, booking_date, description)), created_imports:accounting_imports!accounting_imports_created_transaction_id_fkey(id, booking_date, description)';
/**
 * An account's type, nested under a `chart_of_accounts` embed. Drives
 * `transactionTouchesBank` (type_name === 'Bank'). Resolves without a FK hint
 * because `chart_of_accounts` has exactly one FK to `financial_account_types`.
 */
export const ACCOUNT_TYPE_EMBED = 'account_type:financial_account_types(type_name)';
//# sourceMappingURL=accountingSelects.js.map